/**
 * @generated SignedSource<<4e9581bd49a9bfbad8fcdd6ec81df336>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkflowStatus = "BUSY" | "IDLE" | "UNOBTAINABLE" | "%future added value";
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type VideoDetailsMetadataMutation$variables = {
  id: string;
  metadata: BasicMetadata;
};
export type VideoDetailsMetadataMutation$data = {
  readonly updateEventMetadata: {
    readonly id: string;
    readonly workflowStatus: WorkflowStatus;
  };
};
export type VideoDetailsMetadataMutation = {
  response: VideoDetailsMetadataMutation$data;
  variables: VideoDetailsMetadataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "metadata"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "AuthorizedEvent",
    "kind": "LinkedField",
    "name": "updateEventMetadata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowStatus",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoDetailsMetadataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoDetailsMetadataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63c782f74fdc26407c61ba3fb8c049a9",
    "id": null,
    "metadata": {},
    "name": "VideoDetailsMetadataMutation",
    "operationKind": "mutation",
    "text": "mutation VideoDetailsMetadataMutation(\n  $id: ID!\n  $metadata: BasicMetadata!\n) {\n  updateEventMetadata(id: $id, metadata: $metadata) {\n    id\n    workflowStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d71458669fbf0a8176d59a27de896d9";

export default node;
